import styled from "styled-components";

const FormCardWrapper = styled.div`
  width: 100%;
  height: 75%;
  position: relative;
  bottom: 0;
  left: 0;
`
export default FormCardWrapper;